export type Environment = "local" | "dev" | "prod";

const KNOWN: readonly Environment[] = ["local", "dev", "prod"];

const raw = import.meta.env.VITE_ENVIRONMENT as Environment | undefined;

// Fall back to "local" on anything unrecognised rather than rendering an undefined
// ribbon colour. "test" used to be in this union and never pointed at a real
// environment; the estate runs local, dev and prod.
export const environment: Environment =
  raw && KNOWN.includes(raw) ? raw : "local";

// Brand tokens, not literals — the ribbon has to keep meaning something once the theme
// layer repaints everything around it.
//
// Deliberately not the accent blue for local: --sl-accent now paints every button on the
// page, so a ribbon in it reads as furniture rather than as a signal.
export const environmentColors: Record<Environment, string> = {
  local: "var(--sl-muted)", // your machine, nothing at stake
  dev: "var(--sl-warning)", // amber: real deployment, not real data
  prod: "var(--sl-negative)", // red: this is real
};

export const isProduction = environment === "prod";
